export default __webpack_public_path__ + "static/media/home_vodie.58dcb56e.mp4";